export default {
    path: 'signer',
    component: () => import(/* webpackChunkName: "common-list" */ '@/pages/common/CommonList'),
    meta: {title:'签约人员查看'}
}